import styled from 'styled-components';
import Title from '../text/Title';

const TitleDescription = styled(Title)`
  margin-top: 1rem;
  margin-bottom: 1rem;
`;

const ContentDescription = styled.div`
  color: #9b9b9b;
  margin-top: ${(props) => (props.margintop ? props.margintop : 0)};
  margin-left: ${(props) => (props.marginleft ? props.marginleft : 0)};
  margin-right: ${(props) => (props.marginright ? props.marginright : 0)};
  margin-bottom: ${(props) => (props.margibottom ? props.marginbottom : 0)};
`;

const ShortDescriptionWrapper = styled.div`
  padding-left: 1.5rem;
  margin-top: 3rem;
`;

const IconWrapperDescription = styled.div`
  color: black;
  ${ShortDescriptionWrapper}:hover & {
    color: ${(props) => props.theme.primaryColor};
  }
`;

export {
  TitleDescription,
  ContentDescription,
  IconWrapperDescription,
  ShortDescriptionWrapper,
};
